import { createAction, createActionGroup, emptyProps, props } from '@ngrx/store'
import {
  Basis,
  CTCData,
  IncomingPayoutAgreement,
  PayoutAgreement,
  PayoutData,
  PayoutFrequency
} from './payout-agreement.state'
import { StatutoryCompliances } from '../employee-salary/employee-salary.state'

export const payoutAgreementActions = createActionGroup({
  source: 'Payout Agreement',
  events: {
    'Load All Payout Agreements': props<{ employeeId: string }>(),
    'Load All Payout Agreements Success': props<{
      payoutAgreements: IncomingPayoutAgreement[] | null
    }>(),
    'Load All Payout Agreements Failure': props<{ error: any }>(),

    'Load Payout Agreement': props<{ employeeId: string }>(),
    'Load Payout Agreement Success': props<{ payoutAgreement: IncomingPayoutAgreement | null }>(),
    'Load Payout Agreement Failure': props<{ error: any }>(),

    'Add Business Requirements': props<{ belongsTo: string; employeeId: string }>(),
    'Add Statutory Compliances': props<{ statutoryCompliances: StatutoryCompliances }>(),
    'Update CTC Value': props<{ ctcValue: number }>(),
    'Add CTC Data': props<{
      payoutFrequency: PayoutFrequency
      ctc: number
      currency: string
      basis: Basis
      effectiveFrom: string
      payoutFrom: string
    }>(),
    'Add Payout Data': props<{
      payoutData: PayoutData
    }>(),

    'Add Payout Agreement': props<{ payoutAgreement: PayoutAgreement }>(),
    'Add Payout Agreement Success': props<IncomingPayoutAgreement>(),
    'Add Payout Agreement Failure': props<{ error: any }>(),

    'Clear Payout Agreement': emptyProps()
  }
})

// --- Revision Workflow Actions ---
export const payoutRevisionActions = createActionGroup({
  source: 'Payout Agreement Revision',
  events: {
    'Initiate Payout Revision': props<{
      belongsTo: string | null
      employeeId: string
    }>(),
    'Update Statutory Compliances': props<{
      statutoryCompliances: StatutoryCompliances
    }>(),
    'Update CTC Value': props<{ ctcValue: number }>(),
    'Update CTC Data': props<{ ctc: CTCData }>(),
    'Update Payout Data': props<{ payoutData: PayoutData }>(),

    'Save Revised Payout': props<{ payout: PayoutAgreement }>(),
    'Save Revised Payout Success': props<{ payout: PayoutAgreement }>(),
    'Save Revised Payout Failure': props<{ error: string }>()
  }
})

// --- Update Workflow Actions ---
// Edit Salary
export const editPayout = createAction(
  '[Payout Agreement Update] Edit Payout',
  props<{ payout: PayoutAgreement }>()
)

export const editPayoutSuccess = createAction(
  '[Payout Agreement Update] Edit Payout Success',
  props<{ payout: PayoutAgreement }>()
)

export const editPayoutFailure = createAction(
  '[Payout Agreement Update] Edit Payout Failure',
  props<{ error: string }>()
)
